if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        this.resetZoom();
        activeMedia.classList.add('active');
        this.bindImageZoom(activeMedia);
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      bindImageZoom(activeMedia) {
        if (activeMedia.nodeName !== 'IMG' || activeMedia.dataset.productModalZoomBound) return;

        activeMedia.dataset.productModalZoomBound = 'true';
        activeMedia.setAttribute('role', 'button');
        activeMedia.setAttribute('tabindex', '0');
        activeMedia.setAttribute('aria-label', `${activeMedia.alt || 'Product image'} zoom`);

        activeMedia.addEventListener('click', () => this.toggleZoom(activeMedia));
        activeMedia.addEventListener('pointerup', (event) => event.stopPropagation());
        activeMedia.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.toggleZoom(activeMedia);
        });
      }

      toggleZoom(activeMedia) {
        const container = this.querySelector('[role="document"]');
        if (!container || activeMedia.nodeName !== 'IMG') return;

        const shouldZoom = !container.classList.contains('is-zoomed');
        container.classList.toggle('is-zoomed', shouldZoom);
        activeMedia.setAttribute('aria-pressed', shouldZoom ? 'true' : 'false');

        if (!shouldZoom) {
          activeMedia.scrollIntoView();
          return;
        }

        requestAnimationFrame(() => {
          container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
          container.scrollTop = (activeMedia.offsetHeight - container.clientHeight) / 2;
        });
      }

      resetZoom() {
        const container = this.querySelector('[role="document"]');
        container?.classList.remove('is-zoomed');
        this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
          image.setAttribute('aria-pressed', 'false');
        });
      }
    }
  );
}
